"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var CopyToClipboard_1 = __importDefault(require("Common/Utils/CopyToClipboard"));
var CommentServiceTypes_1 = require("./CommentServiceTypes");
var CommentGroup_1 = __importDefault(require("./CommentGroup/CommentGroup"));
var CommentComponent_1 = __importDefault(require("./CommentComponent/CommentComponent"));
var AddComment_1 = __importDefault(require("./AddCommentComponent/AddComment"));
var CommentDeleteOverlay_1 = __importDefault(require("./CommentDeleteOverlay/CommentDeleteOverlay"));
var CommentPlaceholder_1 = require("./CommentPlaceholder/CommentPlaceholder");
var CommentThread_1 = __importDefault(require("./CommentThread/CommentThread"));
var mobx_1 = require("mobx");
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
var CommentMessage_1 = require("./CommentMessage/CommentMessage");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var InviteNewUser_1 = require("Common/InviteNewUserModal/InviteNewUser");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var inversify_react_1 = require("inversify-react");
var CommentController = (function (_super) {
    __extends(CommentController, _super);
    function CommentController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentlyEditingId = null;
        _this.currentlyDeletingId = null;
        _this.renderThread = function () {
            var _a = _this.props, commentGroupStore = _a.commentGroupStore, user = _a.user, usersInAccount = _a.usersInAccount, mentionsEnabled = _a.mentionsEnabled, permissionsStore = _a.permissionsStore, projectId = _a.projectId;
            var projectStore = _this.projectStore;
            var currentlyDeleting = commentGroupStore.hasComment && commentGroupStore.allComments[0].id === _this.currentlyDeletingId;
            var commentPlaceholder = (0, CommentPlaceholder_1.getPlaceholder)(commentGroupStore);
            var hasEditAccess = !!projectStore ? projectStore.isEditable : false;
            return (react_1.default.createElement("div", { className: "comment-controller__thread-holder" },
                react_1.default.createElement(CommentThread_1.default, { hasEditAccess: hasEditAccess, firstName: user.firstName, lastName: user.lastName, usersInAccount: usersInAccount, commentPlaceholder: commentPlaceholder, mentionsEnabled: mentionsEnabled, onCancelReply: commentGroupStore.cancelReply, onSendReply: commentGroupStore.sendReply, permissionsStore: permissionsStore, projectId: projectId, currentlyDeleting: currentlyDeleting, onConfirmDelete: _this.confirmDeleteThread, onCancelDelete: _this.cancelDelete, onInviteUser: _this.onInviteUser }, _this.renderComments())));
        };
        _this.renderComments = function () {
            var commentGroupStore = _this.props.commentGroupStore;
            return commentGroupStore.allComments.map(function (comment, index) {
                if (_this.currentlyEditingId === comment.id) {
                    return _this.renderEditComment(comment, index);
                }
                else if (index !== 0 && _this.currentlyDeletingId === comment.id) {
                    return _this.renderDeleteOverlayAndComment(comment, index);
                }
                else {
                    return _this.renderSingleComment(comment, index);
                }
            });
        };
        _this.renderDeleteOverlayAndComment = function (comment, index) {
            return (react_1.default.createElement("div", { className: "comment-controller__delete-comment", key: "delete".concat(comment.id) },
                _this.renderSingleComment(comment, index),
                react_1.default.createElement(CommentDeleteOverlay_1.default, { onCancelDelete: _this.cancelDelete, onConfirmDelete: _this.confirmDeleteComment, message: "Confirm delete comment?" })));
        };
        _this.renderEditComment = function (comment, index) {
            var _a = _this.props, user = _a.user, usersInAccount = _a.usersInAccount, mentionsEnabled = _a.mentionsEnabled, permissionsStore = _a.permissionsStore, projectId = _a.projectId;
            return (react_1.default.createElement(AddComment_1.default, { key: comment.id, firstName: user.firstName, lastName: user.lastName, onCancel: _this.cancelEdit, onSend: _this.confirmEdit, startingMessage: comment.message, startingMentions: comment.mentions, usersInAccount: usersInAccount, mentionsEnabled: mentionsEnabled, permissionsStore: permissionsStore, projectId: projectId, onInviteUser: _this.onInviteUser }));
        };
        _this.renderSingleComment = function (comment, index) {
            var _a, _b, _c;
            var _d = _this.props, commentGroupStore = _d.commentGroupStore, user = _d.user, usersInAccount = _d.usersInAccount, pendingUsersDataStore = _d.pendingUsersDataStore;
            var projectStore = _this.projectStore;
            var hasEditAccess = !!projectStore ? projectStore.isEditable : false;
            return (react_1.default.createElement(CommentComponent_1.default, { hasEditAccess: hasEditAccess, key: comment.id, firstName: ((_a = comment.user) === null || _a === void 0 ? void 0 : _a.firstName) || "Deleted", lastName: ((_b = comment.user) === null || _b === void 0 ? void 0 : _b.lastName) || "User", createdAt: comment.createdAt, lastEditedAt: comment.lastEditedAt, isEditable: ((_c = comment.user) === null || _c === void 0 ? void 0 : _c._id) === user._id, isFirst: index === 0, isResolved: commentGroupStore.isResolved, setResolved: commentGroupStore.setResolved, deleteComment: _this.deleteComment(comment.id), editComment: _this.editComment(comment.id), linkComment: _this.copyCommentLink },
                react_1.default.createElement(CommentMessage_1.CommentMessage, { mentions: comment.mentions, usersInAccount: usersInAccount, message: comment.message, pendingUsers: pendingUsersDataStore.getPendingUsers() })));
        };
        _this.deleteComment = function (commentId) {
            return function () {
                if (!_this.currentlyDeletingId) {
                    (0, mobx_1.runInAction)(function () { return (_this.currentlyDeletingId = commentId); });
                }
            };
        };
        _this.confirmDeleteComment = function () { return __awaiter(_this, void 0, Promise, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentlyDeletingId) {
                            throw new Error("Trying to delete a comment when not currently deleting one");
                        }
                        return [4, this.props.commentGroupStore.deleteComment(this.currentlyDeletingId)];
                    case 1:
                        result = _a.sent();
                        if (result === CommentServiceTypes_1.CommentSaveOutcome.Success) {
                            (0, mobx_1.runInAction)(function () {
                                _this.currentlyDeletingId = null;
                            });
                        }
                        return [2, result];
                }
            });
        }); };
        _this.confirmDeleteThread = function () {
            return _this.props.commentGroupStore.deleteThread();
        };
        _this.cancelDelete = function () {
            _this.currentlyDeletingId = null;
        };
        _this.editComment = function (commentId) {
            return function () {
                if (!_this.currentlyEditingId) {
                    (0, mobx_1.runInAction)(function () { return (_this.currentlyEditingId = commentId); });
                }
            };
        };
        _this.cancelEdit = function () {
            _this.currentlyEditingId = null;
        };
        _this.confirmEdit = function (commentMessage, onSuccess) { return __awaiter(_this, void 0, Promise, function () {
            var message, mentions, confirmedEditCommentId, editOutcome;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = commentMessage.message, mentions = commentMessage.mentions;
                        confirmedEditCommentId = this.currentlyEditingId;
                        if (!confirmedEditCommentId) {
                            throw new Error("Trying to confirm an edit when not currently editing");
                        }
                        return [4, this.props.commentGroupStore.editComment(confirmedEditCommentId, message, mentions, onSuccess)];
                    case 1:
                        editOutcome = _a.sent();
                        if (editOutcome === CommentServiceTypes_1.CommentSaveOutcome.Success) {
                            (0, mobx_1.runInAction)(function () {
                                _this.currentlyEditingId = null;
                            });
                        }
                        return [2, editOutcome];
                }
            });
        }); };
        _this.copyCommentLink = function () {
            (0, CopyToClipboard_1.default)(_this.props.commentGroupStore.url);
            _this.props.commentGroupStore.telemetry.trackOnly("Comment Thread Link Copied", {}, { blockIntercom: true });
        };
        _this.onInviteUser = function (email) { return __awaiter(_this, void 0, void 0, function () {
            var acceptedInvite, err_1, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.inviteNewUser(email, Types_1.Action.Edit, TelemetryEnums_1.UserInvitedOrigin.Mention)];
                    case 1:
                        acceptedInvite = _a.sent();
                        return [2, acceptedInvite || false];
                    case 2:
                        err_1 = _a.sent();
                        errorMessage = err_1.message;
                        if (errorMessage.startsWith(ErrorCodes_1.InviteErrorCodes.INVALID_EMAIL_PARTIAL)) {
                            return [2, "Enter a valid email to invite someone to your team"];
                        }
                        else if (errorMessage === ErrorCodes_1.InviteErrorCodes.NO_ACCESS_OUTSIDE_DOMAIN) {
                            return [2, "Invite users who share the same domain as you"];
                        }
                        else if (errorMessage === InviteNewUser_1.ONLY_SAME_DOMAIN_INVITES) {
                            return [2, "Invite users who share the same domain as you"];
                        }
                        else if (errorMessage === InviteNewUser_1.ONLY_ADMINS_CAN_INVITE) {
                            return [2, ""];
                        }
                        else {
                            return [2, "Something went wrong. Please try again."];
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        return _this;
    }
    CommentController.prototype.render = function () {
        var _a = this.props, commentGroupStore = _a.commentGroupStore, containerElem = _a.containerElem;
        return (react_1.default.createElement(CommentGroup_1.default, { isRead: commentGroupStore.isRead, isResolved: commentGroupStore.isResolved, isShowing: commentGroupStore.isShowing, toggleShowing: commentGroupStore.toggleShowing, containerElem: containerElem }, this.renderThread()));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], CommentController.prototype, "currentlyEditingId", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], CommentController.prototype, "currentlyDeletingId", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("projectStore"),
        __metadata("design:type", typeof (_a = typeof ProjectStore_1.default !== "undefined" && ProjectStore_1.default) === "function" ? _a : Object)
    ], CommentController.prototype, "projectStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentController.prototype, "confirmDeleteComment", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentController.prototype, "confirmDeleteThread", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentController.prototype, "cancelDelete", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentController.prototype, "cancelEdit", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentController.prototype, "confirmEdit", void 0);
    CommentController = __decorate([
        mobx_react_1.observer
    ], CommentController);
    return CommentController;
}(react_1.default.Component));
exports.default = CommentController;
